import React, { FC } from "react";
import MergePatientsPageContent from "./MergePatientsPageContent";
import usePatientMerge from "./usePatientMerge";
import { InitialPatient } from "./types";

type MergePatientsContainerProps = {
  initialPatient: InitialPatient;
  onDone: () => void;
  onViewPatient: (selectedPatientId: string) => void;
  onPatientClick: (mrn: string) => void;
};

// Mirrors MergeCustomersContainer — only ever mounts once the caller has
// real patient data, so "isOpen" is simply "always true while mounted".
const MergePatientsContainer: FC<MergePatientsContainerProps> = ({
  initialPatient,
  onDone,
  onViewPatient,
  onPatientClick,
}) => {
  const {
    patients,
    fieldSelections,
    isWard,
    isFamilyMember,
    canSubmit,
    isSubmitting,
    mergeResult,
    errorMessage,
    blockerError,
    addPatient,
    removePatient,
    setFieldSelection,
    setIsWard,
    setIsFamilyMember,
    handleSubmit,
  } = usePatientMerge(initialPatient, true);

  return (
    <MergePatientsPageContent
      patients={patients}
      fieldSelections={fieldSelections}
      isWard={isWard}
      isFamilyMember={isFamilyMember}
      canSubmit={canSubmit}
      isSubmitting={isSubmitting}
      mergeResult={mergeResult}
      errorMessage={errorMessage}
      blockerError={blockerError}
      onFieldSelect={setFieldSelection}
      onAddPatient={addPatient}
      onRemovePatient={removePatient}
      onToggleWard={setIsWard}
      onToggleFamilyMember={setIsFamilyMember}
      onSubmit={handleSubmit}
      onDone={onDone}
      onViewPatient={onViewPatient}
      onPatientClick={onPatientClick}
    />
  );
};

export default MergePatientsContainer;
